import { render, staticRenderFns } from "./dialogShowDetail.vue?vue&type=template&id=8c74df34&scoped=true"
import script from "./dialogShowDetail.vue?vue&type=script&lang=js"
export * from "./dialogShowDetail.vue?vue&type=script&lang=js"
import style0 from "./dialogShowDetail.vue?vue&type=style&index=0&id=8c74df34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c74df34",
  null
  
)

export default component.exports